// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"QhgbT7hWTk wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/ProfileEdit/ProfileEdit.module.less
// module id = 985
// module chunks = 3